module.exports = __webpack_public_path__ + "img/Bookmarkk.740e2dd5.png";